<template>
  <div class="invoiceClipDetail">
    <div class="title">发票信息</div>
    <div class="essentialInformation">
      <div>
        <div class="label">发票抬头</div>
        <div class="text">{{detail.buyerName}}</div>
      </div>
      <div>
        <div class="label">票据类型</div>
        <div class="text">{{detail.invoiceTypeName}}</div>
      </div>
      <div>
        <div class="label">发票号码</div>
        <div class="text">{{detail.invoiceNumber}}</div>
      </div>
      <div>
        <div class="label">发票服务名称</div>
        <div class="text">{{detail.goodsName}}</div>
      </div>
      <div>
        <div class="label">发票代码</div>
        <div class="text">{{detail.invoiceCode}}</div>
      </div>
      <div>
        <div class="label">不含税金额</div>
        <div class="text">{{detail.noTaxAmount}}</div>
      </div>
      <div>
        <div class="label">税率</div>
        <div class="text">{{detail.taxRate}}</div>
      </div>
      <div>
        <div class="label">税额</div>
        <div class="text">{{detail.taxAmount}}</div>
      </div>
      <div>
        <div class="label">价税合计</div>
        <div class="text">{{detail.totalAmount}}</div>
      </div>
      <!-- <div>
        <div class="label">本次报销金额</div>
        <div class="text"></div>
      </div>
      <div>
        <div class="label"></div>
        <div class="text"></div>
      </div> -->
       <div>
        <div class="label">说明</div>
        <div class="text"></div>
      </div>
    </div>
    <div class="title">发票信息 <button @click="$api.look({
      fileName:detail.fileName,
      filePath:detail.filePath
    })">查看</button></div>
  </div>
</template>

<script>
export default {
  created () {
    this.detail = this.$route.query
  },
  data() {
    return {
      detail:{}
    }
  },
};
</script>

<style lang="scss">
.invoiceClipDetail {
  height: 100%;
  .title {
    font-size: 14px;
    display: flex;
    align-items: center;
    // padding: 0 20px 20px;
    padding-left: 20px;
    padding-bottom: 10px;
    button{
        cursor: pointer;
        border: none;
        outline: none;
        color: #fff;
        background: rgb(58, 117, 197);
        width: 70px;
        padding: 2px 0;
        border-radius: 5px;
        margin-left: 20px;
    }
  }
  .essentialInformation {
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    div {
      width: 50%;
      flex-shrink: 0;
      flex-wrap: 0;
      display: flex;
      align-items: center;
      div {
        width: 50%;
        margin: 10px 0;
      }
      .label {
        display: flex;
        justify-content: flex-end;
        font-size: 13px;
        color: rgb(109, 113, 132);
      }
      .text {
        color: rgb(44, 44, 44);
        padding-left: 10px;
        font-size: 13px;
      }
    }
  }
}
</style>